import { useState } from 'react';
import { TextSpan } from '../../../../Atoms/Text';
import { useSnackbar } from '../../../../../Context/SnackbarContext';
import { DEFAULT_ADVANCE_BUTTON_STYLE } from '../../../../../utils/styleHelpers';
import { recalculateFields } from '../../../../../Api/Asset/AssetApi';
import { PageCard } from '../../../../Compounds/CardWithTitle';
import { TFUSettingsTable } from '../../../../Compounds/TFUSettings/TFUSettingsTable';
import { PageLayout } from '../../../../PageLayout';
import { getCurrentWorkflow, startRunTotalsApi } from '../../../../../Api/RunTotal/RunTotalApi';
import { getCurrentWorkflowLinkAllocation, startLinkAllocationsApi } from '../../../../../Api/Link/LinkApi';
import { WorkflowType } from '../../../../../store/WorkflowEvent';
import { CalculationWorkflow } from './CalculationWorkflow';

export const CalculationsTab = () => {
  const { setSnack } = useSnackbar();
  const [started, setStarted] = useState<{ [key: string]: boolean }>({});

  const calculateFields = async (field: string) => {
    const { error } = await recalculateFields(field);
    if (error) {
      setSnack({ message: error.message, type: 'error', open: true });
      return;
    }
    setStarted((prev) => ({ ...prev, [field]: true }));
    setSnack({ message: 'Calculation started', type: 'success', open: true });
  };

  return (
    <PageLayout
      className="w-full"
      dataTestId="calculations-page"
      dataCy="calculations-page-card"
      pageTitle="">
      <div data-testid="calculations-tab">
        <TFUSettingsTable />
        <PageCard
          title="Assets"
          className="mb-5 mt-5">
          <div className="flex p-3">
            <TextSpan className="flex items-center space-x-2">
              <button
                data-cy="calculation-button-efcr"
                disabled={started['efcr']}
                className={`${DEFAULT_ADVANCE_BUTTON_STYLE} mr-10`}
                onClick={() => calculateFields('efcr')}>
                Calculate EFCR
              </button>
              Force calculation of Expected First Commission Run on all Assets.
            </TextSpan>
          </div>
          <div className="flex p-3">
            <TextSpan className="flex items-center space-x-2">
              <button
                data-cy="calculation-button-net-revenue"
                disabled={started['net-revenue']}
                className={`${DEFAULT_ADVANCE_BUTTON_STYLE} mr-10`}
                onClick={() => calculateFields('net-revenue')}>
                Calculate Net Revenue
              </button>
              Force recalculation of Net MRR, Net NRR, and Net Revenue on all Assets.
            </TextSpan>
          </div>
          <div className="flex p-3">
            <TextSpan className="flex items-center space-x-2">
              <button
                data-cy="calculation-button-payment-frequency"
                disabled={started['payment-frequency']}
                className={`${DEFAULT_ADVANCE_BUTTON_STYLE} mr-10`}
                onClick={() => calculateFields('payment-frequency')}>
                Calculate Payment Frequency
              </button>
              Force calculation of Payment Frequency on all Assets and Provisional Assets.
            </TextSpan>
          </div>
          <div className="flex p-3">
            <TextSpan className="flex items-center space-x-2">
              <button
                data-cy="calculation-button-open-commissions-ticket"
                disabled={started['open-commissions-ticket']}
                className={`${DEFAULT_ADVANCE_BUTTON_STYLE} mr-10`}
                onClick={() => calculateFields('open-commissions-ticket')}>
                Calculate Open Tickets
              </button>
              Force calculation of Open Ticket on all Assets and Provisional Assets.
            </TextSpan>
          </div>
        </PageCard>

        <PageCard
          title="Commissions"
          className="mb-5">
          <CalculationWorkflow
            type={WorkflowType.RUN_TOTALS}
            getCurrentWorkflow={getCurrentWorkflow}
            startWorkflow={startRunTotalsApi}
          />
          <CalculationWorkflow
            type={WorkflowType.LINK_ALLOCATIONS}
            getCurrentWorkflow={getCurrentWorkflowLinkAllocation}
            startWorkflow={startLinkAllocationsApi}
          />
        </PageCard>
      </div>
    </PageLayout>
  );
};
